import * as React from "react";
import Svg, { Path,Rect } from "react-native-svg";
const SVGComponent = (props) => (
  <Svg
    width={props.size ? props.size : 24}
    height={props.size ? props.size : 24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <Rect width={42} height={42} rx={4.2} fill={props?.bgColor ?? "#F3F5FC"} />
    <Path
      d="M7.5 9.75H16.5M7.5 12.75H16.5M3 19.5V5.25C3 5.05109 3.07902 4.86032 3.21967 4.71967C3.36032 4.57902 3.55109 4.5 3.75 4.5H20.25C20.4489 4.5 20.6397 4.57902 20.7803 4.71967C20.921 4.86032 21 5.05109 21 5.25V19.5L18 18L15 19.5L12 18L9 19.5L6 18L3 19.5Z"
      stroke={props.color ? props.color : "#1434CB"}
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Svg>
);
export default SVGComponent;
